import React, { useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Button, Paper } from "@material-ui/core";
import Spinners from "../components/common/spinners";
import { useStyles } from "../styles/styles";
import {useParams} from 'react-router-dom'
import ResetPasswordForm from "../components/resetPassword/resetPasswordForm";
import SAMSAPIService from "../api/SAMSService";

export default function ResetPassword(props) {
    const { token } = useParams() // fetch token for reset password
    const urlParams = new URLSearchParams(props.location.search)
    const redirect = urlParams.get('redirect') // true if its SAMS button will activate
    const rtoUrl = urlParams.get('rtoUrl') // redirect to url
    const party = urlParams.get('party') // redirect to url

    const classes = useStyles();
    const [loading, setLoading] = React.useState(true);
    const [passwordReset, setPasswordReset] = React.useState(false)
    const [validLink, setValidLink] = React.useState(false)

    const validateLink = async () => {
        const result = await SAMSAPIService.doGet(
            `user/password/recover/${token}`
        );

        if(result.error === true) setValidLink(false)
        else setValidLink(true)
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        validateLink()
    }, [token])
   
    return (
        <div>
        <Container component="main" maxWidth="xs" className="d-flex align-items-center">
            <CssBaseline />
            <Paper>
            <div className={classes.paper}>
                <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ paddingTop: "45px" }}
                >
                     <Typography component="h1" variant="h4" ><strong>{party ?? "Compatio"}</strong></Typography><br/>
                    {/* <img
                        src={`${process.env.PUBLIC_URL}/assets/logo.png`}
                        style={{ width: "50px", height: "50px" }}
                    /> */}
                </Grid>
                {loading && <Spinners />}

                {
                    !validLink && !loading &&
                    <Container>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            style={{ paddingTop:"20px" }}
                            >
                            <Typography component="h1" variant="h6" align="center">
                                Reset Link Invalid 
                            </Typography>
                        </Grid>
                        <br/>
                        <Typography  component="h1">
                            Please use the link below to generate a new reset link. 
                        </Typography>
                        {/* { 
                            redirect?.toLowerCase() === "true" &&  */}
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                href = {"/forgot_password" + props.location.search}
                                className={classes.submit}
                                // onClick={submitHandler}
                                disabled={loading ? true : false}
                            >
                                Generate reset link
                            </Button>
                        {/* } */}
                    </Container>
                }

                {
                    validLink && (!passwordReset ? 
                    <ResetPasswordForm
                        classes={classes}
                        loading={loading}
                        setLoading={setLoading}
                        setPasswordReset={setPasswordReset}
                        token = {token}
                        party = {party}
                    />
                    :
                    <Container>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            style={{ paddingTop:"20px" }}
                            >
                            <Typography component="h1" variant="h6" align="center">
                                Password reset successful
                            </Typography>
                        </Grid>
                        <br/>
                        <Typography  component="h1">
                            Kindly go to the login page of your application and login using your new password. 
                        </Typography>
                        { 
                            (redirect?.toLowerCase() === "true" || rtoUrl !=null) && 
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                href = {rtoUrl ?? "/login"}
                                className={classes.submit}
                                // onClick={submitHandler}
                                disabled={loading}
                            >
                                Return to sign in
                            </Button>
                        }
                    </Container>)
                }
                
            </div>
            <Box mt={8}>
                <Typography variant="body2" color="textSecondary" align="center">
                {"Copyright © "}
                Compatio
                <span>&nbsp;&nbsp;</span> {new Date().getFullYear()}
                {"."}
                </Typography>
            </Box>
            </Paper>
        </Container>
        </div>
    );
}
